import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  Radio,
  RadioGroup,
} from "@mui/material";
import { grey } from "@mui/material/colors";
import { Dispatch, SetStateAction, useState } from "react";
import {
  OrganizationNiche,
  OrganizationProfile,
  OrganizationVaProfile,
} from "schemas/dashboard";

import { TemplateMethod } from "features/Influencer/ContactList/schema";

import { SaveOrgVaProfileFunc, TemplateScreen } from "../../schema";
import BentoConvo from "./BentoConvo";
import FromScratch from "./FromScratch";

interface Props {
  openTemplateDialog: boolean;
  setOpenTemplateDialog: (open: boolean) => void;
  niche?: OrganizationNiche;
  handleSubmitMethod: (method: TemplateMethod) => void;
  screen: TemplateScreen;
  setScreen: Dispatch<SetStateAction<TemplateScreen>>;
  organizationVaProfile: OrganizationVaProfile | null;
  saveOrgVaProfile: SaveOrgVaProfileFunc;
  organizationProfile: OrganizationProfile | null;
  handleNextStep: () => void;
}

const TemplateCreateDialog = ({
  openTemplateDialog,
  setOpenTemplateDialog,
  niche,
  handleSubmitMethod,
  screen,
  setScreen,
  organizationVaProfile,
  saveOrgVaProfile,
  organizationProfile,
  handleNextStep,
}: Props) => {
  const [method, setMethod] = useState<TemplateMethod | null>(null);
  const onClose = () => {
    setOpenTemplateDialog(false);
  };

  const renderDialog = () => {
    if (screen === TemplateScreen.method) {
      return (
        <>
          <DialogTitle sx={{ textAlign: "center" }}>
            Do you have an existing outreach template?
            <IconButton
              onClick={() => setOpenTemplateDialog(false)}
              sx={{
                position: "absolute",
                top: 8,
                right: 8,
                color: grey[500],
                cursor: "pointer",
                fontSize: 14,
              }}
            >
              <Box component="i" className="fa-solid fa-xmark" />
            </IconButton>
          </DialogTitle>

          <DialogContent>
            <Grid container justifyContent="center">
              <FormControl>
                <RadioGroup
                  value={method}
                  onChange={(e) => setMethod(e.target.value as TemplateMethod)}
                >
                  <FormControlLabel
                    value={TemplateMethod.from_scratch}
                    control={<Radio />}
                    label="Yes, I have one I'd like to use"
                  />
                  <FormControlLabel
                    value={TemplateMethod.use_bento_ai}
                    control={<Radio />}
                    label={"No, use Bento AI to create one 🚀"}
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
          </DialogContent>

          <DialogActions>
            <Button
              disableElevation
              disabled={!method}
              onClick={() => handleSubmitMethod(method!)}
            >
              Next
              <Box
                sx={{ ml: 1 }}
                component="i"
                className="fa-solid fa-arrow-right"
              />
            </Button>
          </DialogActions>
        </>
      );
    } else if (screen === TemplateScreen.bento_ai) {
      return (
        <DialogContent>
          <BentoConvo
            organizationVaProfile={organizationVaProfile}
            saveOrgVaProfile={saveOrgVaProfile}
            handleBack={() => {
              setScreen(TemplateScreen.method);
            }}
            niche={niche}
            handleNextStep={handleNextStep}
          />
        </DialogContent>
      );
    } else if (screen === TemplateScreen.from_scratch) {
      return (
        <DialogContent>
          <FromScratch
            organizationProfile={organizationProfile}
            organizationVaProfile={organizationVaProfile}
            saveOrgVaProfile={saveOrgVaProfile}
            handleBack={() => {
              setScreen(TemplateScreen.method);
            }}
            niche={niche}
            handleNextStep={handleNextStep}
          />
        </DialogContent>
      );
    } else {
      return <></>;
    }
  };

  return (
    <Dialog open={openTemplateDialog} maxWidth="md" fullWidth onClose={onClose}>
      {renderDialog()}
    </Dialog>
  );
};

export default TemplateCreateDialog;
